import type { Sort } from '@carboncopyco/types';

export const INITIAL_URL_STATE = {
  sort: 'last_updated' as Sort,
  creators: '',
  companies: '',
  sources: '',
  q: '',
  status: undefined,
};
